// extracted by mini-css-extract-plugin
module.exports = {"CancelIconContainer":"CloseModalButton_CancelIconContainer__1Yghg","CloseIcon":"CloseModalButton_CloseIcon__2Ujj9"};